require('./aggregatorGenericBox.scss');

import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import { Accordion } from 'commonsComponents/accordion';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import { AccordionBody } from 'commonsComponents/accordionBody';

class AggregatorGenericBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded || false,
    };
  }

  handleOnClick = () => {
    const { expanded } = this.state;
    const { id, onExpand, onToggle } = this.props;

    this.setState({ expanded: !expanded });
    onToggle && onToggle(!expanded);

    !expanded && onExpand && onExpand(id);
  };

  render() {
    const { expanded } = this.state;
    const { header, body } = this.props;
    const genericBoxClasses = classnames('aggregator-generic-box', {
      'aggregator-generic-box--is-expanded': expanded,
      'aggregator-generic-box--is-clickable': !expanded,
    });

    return (
      <div className={genericBoxClasses}>
        <Accordion onClick={this.handleOnClick} isExpanded={expanded}>
          <AccordionHeader name="AccordionHeader">{header}</AccordionHeader>
          <AccordionBody name="AccordionBody">{body}</AccordionBody>
        </Accordion>
      </div>
    );
  }
}

AggregatorGenericBox.propTypes = {
  id: PropTypes.string,
  header: PropTypes.element,
  body: PropTypes.element,
  onExpand: PropTypes.func,
  onToggle: PropTypes.func,
  expanded: PropTypes.bool,
};

export { AggregatorGenericBox };
